import { Box, Container, Typography, useTheme } from '@mui/material'
import React from 'react'
import { LockerBanks } from '../components/LockerBanks'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { 
    checkIfAssignmentIsProperlyConfigured, 
    setDomainAndLockerBankIdInLocalStorage 
} from '../lib/Utils'
import { SUCCESS } from '../assets/constants/Constants'
import { getTenantAndAssignmentSettings } from '../api/api'

const SelectLockerBankPage = () => {
    const theme = useTheme()
    const colorScheme = theme.palette.mode
    const { t } = useTranslation()
    const history = useHistory()

    const { lockerDatas } = history.location.state || {}

    // ✅ Safe fallback
    const safeLockerDatas = lockerDatas || []

    // ✅ Unique locker banks
    const lockerBanks = [
        ...new Map(
            safeLockerDatas.map(item => [item?.locker_bank?.id, item?.locker_bank])
        ).values()
    ]


    // ✅ API + redirect logic
    const getSettingsValidateAndRedirectUser = async (lockerBankId) => {
        try {
            const response = await getTenantAndAssignmentSettings(lockerBankId)

            if (response?.status === SUCCESS) {
                const data = response?.data

                if (!data) return

                const lockerslug = data?.locker_bank?.slug

                // ✅ store slug
                localStorage.setItem("locker_slug", lockerslug)

                const assignments = data?.locker_assignments || []

                // ✅ CASE 1: Multiple assignments → go to assignment selection page
                if (assignments.length > 1) {
                    history.push({
                        pathname: '/assignments',
                        state: { tenantAndAssignmentSettings: data }
                    })
                }

                // ✅ CASE 2: Single assignment → validate and go next
                else if (assignments.length === 1) {
                    const isValid = await checkIfAssignmentIsProperlyConfigured(data)
                    if (isValid === true) {
                        history.push('/home-screen')
                    } else {
                        alert(t(isValid?.errorMessage || 'Something went wrong'))
                    }
                }

                // ✅ CASE 3: No assignments
                else {
                    alert(t('noLockerAssignments'))
                }
            }
        } catch (error) {
            console.error('Error:', error)
        }
    }

    // ✅ Click handler
    const handleLockerClick = (locker) => {
        if (!locker?.id) return
        const domainAndLockerBankInfoObject = {
            domain: "https://euro.durolt.in/",
            lockerBankId: locker.id
        }
        setDomainAndLockerBankIdInLocalStorage(domainAndLockerBankInfoObject)
       getSettingsValidateAndRedirectUser(locker.id)
    }

    return (
        <Container className="select-locker-bank-page" maxWidth="xs">
            <Box className="main-container">
                {lockerBanks.length > 0 ? (
                    lockerBanks.map((locker) => (
                        <LockerBanks
                            key={locker.id}
                            lockerBank={locker}
                            onClick={() => handleLockerClick(locker)}
                        />
                    ))
                ) : (
                    <Typography
                        className={`no-locker-bank-text ${
                            colorScheme === 'dark' ? 'dark-text' : ""
                        }`}
                    >
                        {t('noAvailableLockerBanks')}
                    </Typography>
                )}
            </Box>
        </Container>
    )
}

export default SelectLockerBankPage